import { useCampaign } from "../context/CampaignContext";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { Megaphone, Layers } from "lucide-react";

export function CampaignSwitcher() {
    const {
        currentCampaign,
        campaigns,
        switchCampaign,
        isLoading,
        showAllCampaigns,
    } = useCampaign();

    // Don't show while loading
    if (isLoading) return null;

    // Don't show if no campaigns exist
    if (campaigns.length === 0) return null;

    return (
        <div className="flex items-center mr-2">
            <Select
                value={showAllCampaigns ? "all" : currentCampaign?.id?.toString() || ""}
                onValueChange={(value) =>
                    switchCampaign(value === "all" ? null : Number(value))
                }
            >
                <SelectTrigger className="w-[200px] h-9 gap-2 bg-background/50 backdrop-blur border-muted">
                    <Megaphone className="h-4 w-4 text-muted-foreground shrink-0" />
                    <SelectValue placeholder="Select Campaign">
                        <div className="flex items-center gap-2 overflow-hidden">
                            {showAllCampaigns ? (
                                <>
                                    <Layers className="h-3 w-3 shrink-0" />
                                    <span className="truncate">All Campaigns</span>
                                </>
                            ) : (
                                <>
                                    <span
                                        className="w-2 h-2 rounded-full shrink-0"
                                        style={{ backgroundColor: currentCampaign?.color || '#6366f1' }}
                                    />
                                    <span className="truncate">{currentCampaign?.name || "Select Campaign"}</span>
                                </>
                            )}
                        </div>
                    </SelectValue>
                </SelectTrigger>
                <SelectContent>
                    {/* All Campaigns option */}
                    <SelectItem value="all">
                        <div className="flex items-center gap-2">
                            <Layers className="h-4 w-4 text-muted-foreground" />
                            <span>All Campaigns</span>
                            <Badge variant="secondary" className="ml-auto text-xs">
                                {campaigns.reduce((acc, c) => acc + c.contact_count, 0)}
                            </Badge>
                        </div>
                    </SelectItem>

                    {/* Divider */}
                    <div className="h-px bg-border my-1" />

                    {/* Individual campaigns */}
                    {campaigns.map((campaign) => (
                        <SelectItem key={campaign.id} value={campaign.id.toString()}>
                            <div className="flex items-center gap-2 w-full">
                                <span
                                    className="w-3 h-3 rounded-full shrink-0"
                                    style={{ backgroundColor: campaign.color }}
                                />
                                <span className="truncate flex-1">{campaign.name}</span>
                                <Badge variant="secondary" className="ml-auto text-xs shrink-0">
                                    {campaign.contact_count}
                                </Badge>
                            </div>
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
